<template>
    <div class="m-list-side">
        <!-- 群号 -->
        <RightSideMsg>
            <em>全服团长交流群</em> :
            <strong @click="onQQClick" class="u-link" title="点击复制">
                <a>{{ qq }}</a>
            </strong>
        </RightSideMsg>
        <div class="m-map-side" v-if="client == 'std'">
            <div class="m-header">
                <a href="javascript:;" @click="toMap">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M9.07 11.175a2.95 2.95 0 105.7 1.528 2.95 2.95 0 00-2.086-3.614 2.95 2.95 0 00-3.614 2.086zM4.753 8.086a1.558 1.558 0 10-3.01-.807 1.558 1.558 0 003.01.807zM14.63 3.07a1.558 1.558 0 103.094.384 1.558 1.558 0 00-3.094-.384zM20.79 14.648a1.558 1.558 0 00-.614 3.047h.002l.006.003.006.002h.004a1.557 1.557 0 001.908-1.102 1.557 1.557 0 00-1.313-1.95z" fill="#5B00D1"/><path fill-rule="evenodd" clip-rule="evenodd" d="M17.545 13.158a.327.327 0 00-.351.305c-.16 2.273-1.064 4.021-2.41 5.203-1.307 1.153-3.037 1.771-4.903 1.818.01.132.005.268-.014.403-.01.09-.028.174-.047.258 2.049-.032 3.957-.707 5.4-1.982 1.467-1.294 2.452-3.193 2.63-5.654a.327.327 0 00-.305-.351zM5.194 14.803c1.181 1.34 2.93 2.245 5.203 2.41a.327.327 0 11-.047.652c-2.46-.174-4.36-1.163-5.653-2.63-1.275-1.444-1.95-3.352-1.983-5.4.084.018.174.037.258.046.136.019.272.024.403.014.047 1.87.666 3.596 1.819 4.908zM4.392 3.9c-.319.52-.586 1.055-.81 1.59.079.008.159.027.238.05a2.326 2.326 0 01.394.145c.206-.487.455-.97.74-1.443.394-.647.859-1.28 1.398-1.88a.327.327 0 00-.024-.464.327.327 0 00-.464.024A13.028 13.028 0 004.392 3.9zm1.903 6.816a.327.327 0 00.352-.305c.164-2.269 1.069-4.017 2.41-5.203 1.307-1.153 3.037-1.772 4.902-1.819a1.948 1.948 0 01.014-.403c.01-.09.029-.174.047-.258-2.048.033-3.956.708-5.4 1.983-1.467 1.294-2.451 3.192-2.63 5.653a.327.327 0 00.305.352zM19.96 4.41A11.815 11.815 0 0018.37 3.6c-.01.08-.028.16-.051.24 0 .004 0 .013-.005.022a2.322 2.322 0 01-.14.37c.487.207.97.455 1.443.741.647.394 1.28.858 1.88 1.397a.327.327 0 00.464-.023.327.327 0 00-.023-.464 13.027 13.027 0 00-1.979-1.472zm-1.307 4.664c-1.182-1.34-2.93-2.245-5.204-2.41a.33.33 0 01.047-.656c2.461.174 4.36 1.163 5.653 2.63 1.275 1.444 1.95 3.352 1.983 5.4a2.472 2.472 0 00-.258-.047 1.947 1.947 0 00-.403-.014c-.047-1.865-.665-3.595-1.818-4.903zm1.607 9.314a11.814 11.814 0 01-.81 1.59 13.36 13.36 0 01-1.472 1.977.327.327 0 01-.465.024.327.327 0 01-.023-.464 12.582 12.582 0 001.397-1.88c.286-.473.534-.956.74-1.444a2.326 2.326 0 00.379.143l.015.002c.08.024.16.038.24.052zM3.881 19.467c.52.319 1.055.586 1.59.811.013-.08.027-.16.05-.239 0-.005 0-.014.006-.023.037-.132.084-.253.14-.37-.487-.207-.97-.455-1.444-.741a12.669 12.669 0 01-1.88-1.397.327.327 0 00-.463.023.327.327 0 00.023.464c.633.572 1.299 1.06 1.978 1.472z" fill="#000"/><path d="M9.21 20.803a1.558 1.558 0 00-3.047-.614c.001.002 0 .006-.001.01l-.003.009a1.556 1.556 0 001.102 1.908 1.557 1.557 0 001.95-1.313z" fill="#5B00D1"/></svg>
                    <span class="u-title">百战异闻录</span>
                </a>
            </div>
            <div class="u-time">最后更新时间: {{ update_time }}</div>
            <BMap mode="list"></BMap>
            <!-- <div class="u-tabs" v-if="maps.length">
                <div
                    class="u-tab"
                    :class="activeIndex === i && 'is-active'"
                    v-for="i in base"
                    :key="i"
                    @click="activeIndex = i"
                >
                    {{ (i - 1) * per + 1 }}~{{ i * per }}
                </div>
            </div>
            <div class="u-list" v-if="maps.length">
                <div
                    class="u-item"
                    ref="mapItem"
                    :class="getSpecialStyle(index)"
                    v-for="(item, index) in maps"
                    :key="item.dwBossID"
                    @click="toMap(index)"
                >
                    <div class="u-item-left">
                        <div class="u-index">{{ index + 1 }}</div>
                        <div class="u-avatar">
                            <img :src="item.bossAvatar" :alt="item.bossName" />
                        </div>
                        <div class="u-name">{{ item.bossName }}</div>
                    </div>
                    <div v-if="item.nEffectID" class="u-item-right">
                        <img :src="iconLink(item.effect.dwIconID)" />
                    </div>
                </div>
            </div> -->
        </div>
    </div>
</template>

<script>
import { moment } from "@jx3box/jx3box-common/js/moment";
import BMap from "@jx3box/jx3box-bmap/src/components/BMap.vue";
export default {
    name: "MapSide",
    components: {
        BMap,
    },
    data() {
        return {
            loading: false,
            qq: "785597424",
        };
    },
    computed: {
        update_moment() {
            return moment(this.$store.state.baizhan.map.updated_at);
        },
        update_time() {
            return this.update_moment.format("YYYY/MM/DD HH:mm:ss");
        },
        client() {
            return this.$store.state.client;
        },
    },
    methods: {
        toMap() {
            let url = `${location.origin}/fb/baizhan`;
            window.open(url, "_blank");
        },
        onQQClick() {
            navigator.clipboard.writeText(this.qq).then(() => {
                this.$notify({
                    title: "复制成功",
                    message: "内容：" + this.qq,
                    type: "success",
                });
            });
        },
    },
    mounted() {},
};
</script>

<style lang="less">
@import "~@/assets/css/baizhan/map_side.less";
</style>
